module.exports = __webpack_public_path__ + "img/map_10.72f69617.webp";